import { FC } from 'react';
import { twMerge } from '@dynamika-shared/utils/twMerge';

export type EventTagProps = {
  label: string;
  className?: string;
};

/**
 * Outlined pill naming a notification event. Unlike `StatusPill` it is neutral
 * — it labels an event, it does not colour-code a delivery status.
 */
export const EventTag: FC<EventTagProps> = ({ label, className }) => (
  <div
    className={twMerge(
      'border-pastelBlue flex items-center justify-center whitespace-nowrap rounded-[0.8rem] border border-solid px-[1.2rem] py-[0.2rem]',
      className
    )}
  >
    <span className='text-1424 text-black font-sans font-medium'>{label}</span>
  </div>
);
